



export default class RW{

	static elements = {
		widget: 	null,
		image: 		null,
		content: 	null,
		title: 		null,
		description: null,
		date: 		null
	};

	static nav = {
		btnPrev: 	null,
		btnNext: 	null,
		items: 		null,
		activeItem: null,
		pageId: 	0
	}

	static data = null;;

	static imageEls = [];





	/*
		**	[Method]	handler_ImageOnload()
		*
		*	@desc	Event handler callback for load events dispatched
					on each image data.
		*
		*	@param	(EventObject)	$event
					Event object that describes the dispathced even.
		*
		*	@return		void
		*	@access		public static
	*/
	static handler_ImageOnload(event){
		let imageId = parseInt(event.currentTarget.getAttribute('data-image-id'));

		/*
			*	Set the loaded status to true.
		*/
		RW.imageEls[imageId].loaded = true;

		// console.log(`[LOADED]\tImage(${imageId})`, event, `Loaded Status: ${RW.imageEls[imageId].loaded}`);

		/*
			*	Check if the current page id is the page id of the loaded image.
		*/
		// console.log(`Image Id: ${imageId} \t Page Id: ${RW.nav.pageId}`);
		if(RW.nav.pageId === imageId){
			/*
				*	Update the image element.
			*/
			RW.elements.image.src = event.currentTarget.src;
			RW.updatePageItems();
			RW.updateSlider(RW.nav.pageId);

			console.log(`Page ${RW.nav.pageId} is updated with the loaded image.`);
		}
	}





	/*
		**	[Method]	updatePageItems()
		*
		*	@desc	This method updates active page item bullet style
					based on the current page id.
		*
		*	@param	(paramType)	$paramName
					Param description.
		*
		*	@return		void
		*	@access		public static
	*/
	static updatePageItems(){
		/*
			*	For IE11 Compatibility - A weird error is happening here while
				changing the active item class so we are returning false without
				changing page items if the browser is IE11.
		*/
		if(!!window.MSInputMethodContext){
			return false;
		}
		else{
			RW.nav.activeItem.classList.remove('rw-page-item--active');
			RW.nav.activeItem = RW.nav.items[RW.nav.pageId];
			RW.nav.activeItem.classList.add('rw-page-item--active');			
		}
	}





	/*
		**	[Method]	handler_Prev()
		*
		*	@desc	Event handler callback for click events dispatched on
					<RW Prev Button> element.
		*
		*	@param	(EventObject)	$event
					Event object that describes the dispatched event.
		*
		*	@return		void
		*	@access		public static
	*/
	static handler_Prev(event){
		// console.log(event);
		/*
			*	Check if there is any previous pageId.
		*/
		if(RW.nav.pageId === 0){
			RW.nav.pageId = RW.data.length - 1;
		}
		else{
			/*
				*	Decrement the pageId by one.
			*/
			RW.nav.pageId--;
		}

		/*
			*	Update the page items.
		*/
		RW.updatePageItems();


		/*
			*	Update the slider content with the new data.
		*/
		RW.updateSlider(RW.nav.pageId);
	}





	/*
		**	[Method]	handler_Next()
		*
		*	@desc	Event handler callback for click events dispatched on
					<RW Next Button> element.
		*
		*	@param	(EventObject)	$event
					Event object that describes the dispatched event.
		*
		*	@return		void
		*	@access		public static
	*/
	static handler_Next(event){
		// console.log(event);

		/*
			*	Check if there is any next pageId.
		*/
		if(RW.nav.pageId === (RW.data.length - 1)){
			RW.nav.pageId = 0;
		}
		else{
			/*
				*	Increment the pageId by one.
			*/
			RW.nav.pageId++;
		}

		/*
			*	Update the page items.
		*/
		RW.updatePageItems();

		/*
			*	Update the slider content with the new data.
		*/
		RW.updateSlider(RW.nav.pageId);
	}




	/*
		**	[Method]	updateSlider()
		*
		*	@desc	This method updates the slider content based on the
					specified data object id.
		*
		*	@param	(int)	$id
					ID of the RW.data object to be updated as the slider content.
		*
		*	@return		void
		*	@access		public static
	*/
	static updateSlider(id){

		/*
			*	Store the data.
		*/
		let data = RW.data[id];

		/*
			*	Update the elements.
		*/
		RW.elements.title.innerText 		= data.title;
		RW.elements.description.innerText 	= data.description;
		RW.elements.date.innerText 			= data.date;

		/*
			*	Check if the specified data object's image is loaded.
		*/
		let image = RW.imageEls[id];
		if(image.element.complete === true){
			RW.elements.image.src = image.element.src;
		}
		else{
			// Reset the image src from the previous page.
			// RW.elements.image.src = '';
			RW.elements.image.src = '';
			// RW.elements.image.style.backgroundColor = 'blue';
		}
	}
}